import styled from 'styled-components';
import { StyledPopupWidgetCon, StyledProductItemCon } from '../../../../skins';

export const StyledCentralBundlePopupWidgetCon = styled(StyledPopupWidgetCon)`
  max-height: 550px;

  & .mr-popup-widget__products-container {
    margin: -1px 0px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const StyledCentralBundleProductItemCon = styled(StyledProductItemCon)`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  & .mr-product-item__body-wrapper {
    flex-direction: column;
    align-items: center;
  }

  & .mr-product-item__body {
    flex-grow: 0;
  }

  & .mr-product-body__details {
    display: flex;
    flex-direction: column;
  }

  & .mr-product-item__actions--vertical-full-width {
    width: 100%;
  }
`;
